var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"field"},[_c('vs-text',{staticClass:"label",attrs:{"type":"alt-paragraph"}},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"content"},[(_vm.value)?_c('vs-text',[_vm._v(_vm._s(_vm.value))]):_vm._e(),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }